<template>
    <div class="bread">
        <ul>
            <li v-for="(item, index) of nav" :key="index">
                <router-link :to="item.path">
                {{item.meta.title}} <span v-if="index < nav.length -1"> ＞ </span>
                </router-link>
            </li>  
        </ul>
    </div>
</template>
<script>
export default {
    data(){
        return{
            nav: []
        }
    },
    methods:{
        setBreadNav(){
            this.nav = this.$router.history.current.matched
            this.nav[0].path = "/"
        }
    },
    created(){
        this.setBreadNav()
    },
    watch:{
        $route(){
            this.setBreadNav()
        } 
               
    }
}
</script>
<style lang="scss" scoped>
    .bread{
        font-size: 0.12rem;
        margin: 0.2rem 0;
        ul{
           
             li{
                display: inline-block;
                a{
                    color: #909090;
                }
            }
        }
    }
</style>